export enum strikesViewTypes {
    WEEKLY = 'weekly',
    MONTHLY = 'monthly',
}
